import React, {useState} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import GlobalState, { changepopupdeleteWorkspace, changemikrosegmentations, changepopupdeleteColumn, changepopupdeleteClause, setifblock, addactivedataset} from "../../../stores/GlobalState";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"

const PopupDeleteWorkspace = observer(() =>{


    const deleteclauseline = async () => {
        
        if(GlobalState.clauseType==1)
        {

            var token = localStorage.getItem("token");
            var t = [];
            var atrim = GlobalState.ifblock;
            setifblock([]);

            atrim.map((n, id)=>
            {
                if(id == GlobalState.ispopupdeleteClauseId)
                {  
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            
            setifblock(t);

            if(GlobalState.clauseCre==1){

            

                var t = [];
                var id_d = '';
                GlobalState.dataset?.map((n, id)=>
                    n.name == GlobalState.activeDatasetClause?id_d=n.id:<></>
                )  
                var rules = [];
                var l = [];
                var l2 = [];
                GlobalState.ifblock.map((n, id)=>
                {
                    l = [];
                    n.list?.map((g, id2)=>
                    {
                        
                        if(g.type=="categorical")
                        {
                            l2 = [];
                            
                            g.operator?.map((v, f)=>{
                                l2 = [];
                                v.value?.map((gh)=>
                                {
                                    if(gh.check==true)
                                    {
                                        l2 = [...l2, gh.name]
                                    }
                                }
                                )
                                l = [...l, {column: g.activColumn, operator: v.operator, value: l2}]
                            })
                            
                        }
                        else
                        {
                            g.operator?.map((v, f)=>{
                                l = [...l, {column: g.activColumn, operator: v.operator, value: v.value}]
                            })
                        }
                        
                    }
                    )
                    rules = [...rules,{conditions: l, newValue: n.then} ]
                }
                )
                var token = localStorage.getItem("token");
                
                var attr = {
                    datasetId: GlobalState.activeDatasetClause,
                    rules: rules,
                    rewrite: true,
                    newColumnName: GlobalState.inputNameClause,
                    othersValue: GlobalState.elsevalClause
                };
                
                console.log(attr);

                localStorage.setItem("countactivetime", Date.now());
                
                const response = await fetch(Domen.url + `portraits/add_rule_based_attribute`, {
                    method: 'POST',
                    headers: {
                        'Authorization': token,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(attr),
                })
                if(response.status=="200"||response.status=="202")
                {
                    const data = await response.json();
                    //changepopupdeleteClause();
                    //changesegmentationpage('2');
                    //location.href = location.href
                }
                else
                {
                    alert("Something went wrong, request status:" + response.status)
                }
            }
            else
            {
                changepopupdeleteClause();
            }
        }
        else
        {
            var t = [];
            var l = [];
            var l0 = [];
            var op = [];
            var atrim = GlobalState.ifblock;
            var VID = GlobalState.VId2;
            setifblock([]);
            atrim.map((n, id)=>
            {
                    
                    if(id == GlobalState.ispopupdeleteClauseId)
                    {
                        l = [];
      
                        n.list?.map((y, id2)=>
                        {
                           
                            if(id2 == GlobalState.ispopupdeleteClauseVId)
                            {
                                l0 = [];
                                y.operator.map((ty, ty2)=>
                                    ty2==VID?
                                    <></>
                                    :
                                    l0 = [...l0, {operator:ty.operator, value:ty.value, select:ty.select}]
                                )
                               
                                if(l0&&l0.length>=1)
                                {
                                    l = [...l, {title: y.title, activColumn: y.activColumn||"", type: y.type||"", operator: l0}]
                                }
                                else
                                {
                                    
                                }
                                
                            }
                            else{
                                l = [...l, {title: y.title, activColumn: y.activColumn||"", type: y.type||"", operator: y.operator||""}]
                                
                            }
                        })
                        if(l.length>=1)
                        {
                            t = [...t, {then: n.then||"", list: l||[]}]
                        }
                        else
                        {
                            l = [{title:"if",activColumn:"",type:"",operator:[{operator:"",value:"",select:""}]}];
                            t = [...t, {then: n.then||"", list: l||[]}]
                        }
                        
                    }
                    else
                    {
                        t = [...t, {then: n.then||"", list: n.list||[]}]
                    }
            })
            
            setifblock(t);
            if(GlobalState.clauseCre==1){
          
                var rules = [];
                var l = [];
                var l2 = [];
                GlobalState.ifblock.map((n, id)=>
                {
                    l = [];
                    n.list?.map((g, id2)=>
                    {
                        
                        if(g.type=="categorical")
                        {
                            l2 = [];
                            
                            g.operator?.map((v, f)=>{
                                l2 = [];
                                v.value?.map((gh)=>
                                {
                                    if(gh.check==true)
                                    {
                                        l2 = [...l2, gh.name]
                                    }
                                }
                                )
                                l = [...l, {column: g.activColumn, operator: v.operator, value: l2}]
                            })
                            
                        }
                        else
                        {
                            g.operator?.map((v, f)=>{
                                l = [...l, {column: g.activColumn, operator: v.operator, value: v.value}]
                            })
                        }
                        
                    }
                    )
                    rules = [...rules,{conditions: l, newValue: n.then} ]
                }
                )
                var token = localStorage.getItem("token");
                
                var attr = {
                    datasetId: GlobalState.activeDatasetClause,
                    rules: rules,
                    rewrite: true,
                    newColumnName: GlobalState.inputNameClause,
                    othersValue: GlobalState.elsevalClause
                };
                
                console.log(attr);

                var flag = 0;
                GlobalState.ifblockNull.map((n, id)=>{
                    if(GlobalState.ispopupdeleteClauseId == id)
                    {
                        n.list.map((t, id2)=>{
                            if(VID == id2)
                            {
                                flag = 1;
                            }
                        })
                    }
                })
              
                
                if(flag==1)
                {

                    localStorage.setItem("countactivetime", Date.now());

                    const allFilled = rules.every(rule =>
                        Object.values(rule).every(value => value !== undefined && value !== null && value !== '')
                    );
                    if(allFilled){
                        const response = await fetch(Domen.url + `portraits/add_rule_based_attribute`, {
                            method: 'POST',
                            headers: {
                                'Authorization': token,
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(attr),
                        })
                        if(response.status=="200"||response.status=="202")
                        {
                            const data = await response.json();
                            changepopupdeleteClause();
                            //changesegmentationpage('2');
                            //location.href = location.href
                        }
                        else
                        {
                            alert("Something went wrong, request status:" + response.status)
                        }
                    }
                }
                else
                {
                    changepopupdeleteClause();
                }
               
            }
            else
            {
                changepopupdeleteClause();
            }
        }
    };
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    return (
        <div className="popupInfofon ">
            <div className="popupInfo deleteProduct">
                <div className='top-element'>
                    {/* <div className='separator'></div> */}
                    <div></div>
                    <div className='buttonspopup'>
                        <div className='buttonexit' onClick={changepopupdeleteClause}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='form-element'>
                    <div className='titlePopupDelete'>
                        Are You sure  that you want to<br/>
                        <span>Delete clause?</span>
                        
                    </div>
                    <div className='buttonsPopupDelete'>
                        <div className='buttonPopupDelete_select' onClick={changepopupdeleteClause}>
                            {langv?.groupsettings?.popupdeleteproduct?.text2}
                        </div>
                        <div className='buttonPopupDelete_select active' onClick={() =>deleteclauseline()}>
                            {langv?.groupsettings?.popupdeleteproduct?.text3}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PopupDeleteWorkspace;
